export default "__VITE_ASSET__80aeb71c__"